import { useSupplierGroups } from 'hooks/useSupplierGroups';
import { useState } from 'react';
import { Device } from 'types';
import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useLazyPatchUpdateDeviceQuery } from 'store/services';

export interface GroupSelectorProps {
    device: Device;
}

/** Dropdown component where user can update a given device's group attribute. The dropdown is populated with all available groups for the supplier and a None option. */
export const GroupSelector = ({ device }: GroupSelectorProps) => {
    const [selectedGroup, setSelectedGroup] = useState<string>(
        device.group ?? ''
    );
    const groups = useSupplierGroups();
    const groupOptions = groups
        ? [
              ...groups.map((g) => ({
                  name: g.name,
                  value: g.name,
              })),
              { name: 'None', value: '' },
          ]
        : [
              { name: 'None', value: '' },
              ...(device?.group
                  ? [{ name: device.group, value: device.group }]
                  : []),
          ];
    const [updateDeviceQuery] = useLazyPatchUpdateDeviceQuery();

    /** When the user selects a group from the dropdown, make network call to update the device's group. */
    const changeGroup = (event: SelectChangeEvent<string>) => {
        setSelectedGroup(event.target.value);
        const updatedFields: Partial<Device> = { group: event.target.value };
        updateDeviceQuery({
            deviceId: device.deviceId,
            updatedFields,
        });
    };

    return (
        <Select
            data-testid="GroupSelector"
            onChange={changeGroup}
            value={selectedGroup}
            displayEmpty
            size="small"
            defaultValue=""
            margin="dense"
            sx={{ width: '100%' }}
        >
            <MenuItem value="">None</MenuItem>
            {!!groupOptions &&
                groupOptions.map((group) => {
                    return (
                        <MenuItem key={group.name} value={group.value}>
                            {group.name}
                        </MenuItem>
                    );
                })}
        </Select>
    );
};
